import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, ReplaySubject } from 'rxjs';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root',
})
export class LineUpService {

  private changes$ = new BehaviorSubject<any>(false);
  changesLineUp$ = this.changes$.asObservable();

  constructor(private http: HttpClient) {}

  emitChanges() {
    this.changes$.next(true);
  }

  getSummary(filter: any): Observable<any> {
    return this.http.post<any>(`${environment.apis.lineupUrl}lineup/v1/summary`, filter);
  }

  getEtaChart(terminalId): Observable<any> {
    return this.http.get<any>(`${environment.apis.lineupUrl}lineup/v1/vessel-arrival?operator=${terminalId}`);
  }

  omit(ids: number[]): Observable<any> {
    return this.http.put(`${environment.apis.lineupUrl}manual-changes/v1/omit/${ids.join(',')}`, {});
  }

  undoOmit(ids: number[]): Observable<any> {
    return this.http.put(`${environment.apis.lineupUrl}manual-changes/v1/undo-omit/${ids.join(',')}`, {});
  }

  active(ids: number[]): Observable<any> {
    return this.http.put(`${environment.apis.lineupUrl}lineup/v1/active/${ids.join(',')}`, {});
  }

  inactive(ids: number[]): Observable<any> {
    return this.http.delete(`${environment.apis.lineupUrl}lineup/v1/${ids.join(',')}`);
  }

  update(id: number, updateLineUp: any): Observable<any> {
    return this.http.put(`${environment.apis.lineupUrl}manual-changes/v1/${id}`, updateLineUp);
  }

  getChanges(id: number): Observable<any> {
    return this.http.get<any>(`${environment.apis.lineupUrl}manual-changes/v1/${id}`);
  }

  getRotation(vessel: any, status: Array<number> = [], limitInDays: number = null): Observable<any> {

    let query = status.length > 0 ? `?${status.map(s => `status=${s}`).join('&')}` : '';
    
    if (limitInDays)
      query += !query ? `?limitInDays=${limitInDays}` : `&limitInDays=${limitInDays}`  

    return this.http.post<any>(`${environment.apis.lineupUrl}lineup/v1/rotation${query}`, vessel);
  }

  accept(id, type) {
    return this.http.put(`${environment.apis.lineupUrl}manual-changes/v1/accept/${id}?type=${type}`, {});
  }

  reject(id, type) {
    return this.http.put(`${environment.apis.lineupUrl}manual-changes/v1/reject/${id}?type=${type}`, {});
  }

  getEtaCalculated(lineupIdOrigin, lineupIdDestination, speed): Observable<any> {
    return this.http.get<any>(`${environment.apis.lineupUrl}lineup/v1/eta-calculated?lineUpIdOrigin=${lineupIdOrigin}&lineUpIdDestination=${lineupIdDestination}&speed=${speed}`);
  }

  getDetails(lineupId) {
    return this.http.get<any>(`${environment.apis.lineupUrl}details/v1/${lineupId}`);
  }

  sendAdjustEta(body: any): Observable<any> {
    return this.http.post<any>(`${environment.apis.lineupUrl}lineup/v1/send-adjust-eta`, body);
  }

  getVesselArrival(terminaId) {
    return this.http.get<any>(`${environment.apis.lineupUrl}lineup/v1/vessel-arrival?terminalId=${terminaId}`);
  }
}